import { render } from "./SkillIcon.vue?vue&type=template&id=e7df98d4&scoped=true"
import script from "./SkillIcon.vue?vue&type=script&lang=js"
export * from "./SkillIcon.vue?vue&type=script&lang=js"

import "./SkillIcon.vue?vue&type=style&index=0&id=e7df98d4&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7df98d4"]])

export default __exports__